export enum InsuranceTabsEnum {
  Active = 'active',
  Inactive = 'inactive',
}
